






























import { Component, Vue } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { observeUser } from '@/firebaseApp';
import Teacher from '@/services/Teacher';
import { Teacher as ITeacher } from '@/models/Teachers';
import AdminMenu from '@/components/admin/AdminMenu.vue';
import Module from '@/components/global/Module.vue';
import ModalContainer from '@/components/modals/ModalContainer.vue';
import { ModuleActions } from '@/models/Enums';
import { IModule } from '@/models/Modules';
import Modules from '@/services/Modules';

@Component({
  components: { draggable, ModalContainer, Module, AdminMenu },
})
export default class AdminTeacherDashboard extends Vue {
  public user: firebase.User | null = null;
  public teacher: ITeacher | null = null;
  public modules: IModule[] = [];
  public moduleOrder: string[] = [];
  public orderedModules: IModule[] = [];
  public initiated = false;

  async created() {
    const teacherId = this.$route.params.id;
    this.teacher = (await Teacher.getTeacherById(teacherId)) as ITeacher;
    await this.watchModulesOrder();
    await this.getData();
    observeUser(user => (this.user = user));
  }

  async getData() {
    if (!this.teacher?.email) {
      return;
    }

    const observer = Modules.getModulesObserverByTeacherEmail(this.teacher.email);
    if (observer) {
      await observer.onSnapshot(async snapshot => {
        if (!snapshot.empty) {
          const modules: IModule[] = [];

          snapshot.forEach(doc => {
            const module = doc.data() as IModule;
            module.id = doc.id;
            modules.push(module);
          });

          this.modules = modules;
          this.orderData();

          this.initiated = true;
        } else {
          this.initiated = true;
        }
      });
    } else {
      this.initiated = true;
    }
  }

  async watchModulesOrder() {
    if (!this.teacher?.email) {
      return;
    }

    const observer = Teacher.getTeacherObserverByEmail(this.teacher.email);
    if (observer) {
      await observer.onSnapshot(async snapshot => {
        if (!snapshot.empty) {
          this.moduleOrder = (snapshot.docs[0].data() as ITeacher).modules;
          this.orderData();
        }
      });
    }
  }

  orderData() {
    if (!this.modules || this.modules.length === 0) {
      return;
    }

    // @ts-ignore
    this.orderedModules = this.moduleOrder.reduce((all, mId) => {
      const module = this.modules.find(m => m && m.id === mId);
      if (module) {
        all.push(module);
      }

      return all;
    }, [] as IModule[]);
  }

  createModule() {
    if (this.teacher?.modules) {
      this.$emit('create-module');
    }
  }

  get moduleActions() {
    return [ModuleActions.Delete, ModuleActions.Edit];
  }

  async deleteModule(id: string) {
    if (id && this.teacher?.id) {
      await Modules.deleteModule(id, this.teacher);
    }
  }

  async editModule(module: IModule) {
    this.$emit('edit-module', module);
  }

  updateModuleOrder() {
    if (!this.teacher?.id) {
      return;
    }

    const moduleIds = this.orderedModules.map(m => m.id) as string[];
    Teacher.updateTeachermModuleOrder(this.teacher.id, moduleIds);
  }
}
